import styled from 'styled-components';

export const LogoSvg = styled.svg`

    * {
        fill: white;
        stroke: white;
    }

`;
